export default __webpack_public_path__ + "static/Boost-f3067e295e59044c19edda48abb0d7e8.webp";